import { ReportType } from '@app/model/market_state/_export/MarketStateExportReport';

export enum ReportExecutionSource {
	ON_DEMAND = 'ON_DEMAND',
	DELIVERY_SCHEDULE = 'DELIVERY_SCHEDULE',
}

export enum ReportExecutionState {
	NEW = 'NEW',
	IN_PROCESS = 'IN_PROCESS',
	SUCCESS = 'SUCCESS',
	FAILED = 'FAILED',
}

type ReportExecution = {
	effectiveFormat?: 'XLSX' | 'CSV'
	id: number
	companyHotelId: number
	reportId: number
	reportType: ReportType
	source: ReportExecutionSource
	deliveryExecutionId?: number
	profileId?: number
	creationDate: string
	executionDate?: string
	finishedDate?: string
	state: ReportExecutionState
	reason?: string
	filename?: string
}

export default ReportExecution;
